import { DefaultBackdropProps } from "../../components/default-backdrop";
import { DefaultDialogProps } from "../../components/default-dialog";
import { DefaultMessageProps } from "../../components/default-message";

export type BaseLayoutState = {
  dialogProps: DefaultDialogProps;
  messageProps: DefaultMessageProps;
  backdropPros: DefaultBackdropProps;
  loading: boolean;
};

export enum ACTION_TYPES {
  setDialogProps = 'setDialogProps',
  setMessageProps = 'setMessageProps',
  setBackdropPros = 'setBackdropPros',
  setLoading = 'setLoading',
}

export const BaseLayoutReducer = (state: BaseLayoutState, action: any): BaseLayoutState => {
  const { type, payload } = action;
  switch (type) {

    case ACTION_TYPES.setDialogProps:
      return {
        ...state,
        dialogProps: payload,
      };
    case ACTION_TYPES.setMessageProps:
      return {
        ...state,
        messageProps: payload,
      };
    case ACTION_TYPES.setBackdropPros:
      return {
        ...state,
        backdropPros: payload,
      };
    case ACTION_TYPES.setLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}